// Shared CSV export helper. Serializes rows to UTF-8 CSV with a BOM so Excel
// (es-ES) opens accented characters and the € symbol correctly.
// `columns` is an array of { key, label, format? } where `format(value, row)`
// is an optional per-cell formatter (e.g. currency / date).
export const downloadCSV = (filename, columns, rows) => {
  const escape = (val) => {
    const s = val === null || val === undefined ? "" : String(val);
    return `"${s.replace(/"/g, '""')}"`;
  };

  const header = columns.map((c) => escape(c.label)).join(",");
  const body = rows
    .map((row) =>
      columns
        .map((c) => {
          const raw = row[c.key];
          const value = c.format ? c.format(raw, row) : raw;
          return escape(value);
        })
        .join(",")
    )
    .join("\n");

  const csv = "\uFEFF" + header + "\n" + body;
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  const stamp = new Date().toISOString().split("T")[0];
  link.download = `${filename.replace(/\s+/g, "_")}_${stamp}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const csvCurrency = (v) =>
  new Intl.NumberFormat("es-ES", { style: "currency", currency: "EUR" }).format(Number(v) || 0);

export const csvDate = (v) =>
  v ? new Date(v).toLocaleDateString("es-ES", { day: "2-digit", month: "2-digit", year: "numeric" }) : "";
